/* Gift option markup and step logic reused from this theme's main-product/product.js. */
(() => {
  var NAIRE_METHOD_FIELDS = [
    [],
    ['姓①'],
    ['名①', 'ふりがな'],
    ['姓①', '姓②'],
    ['姓①', '姓②', '姓③'],
    ['姓①', '名①', '姓②', '名②', '姓③', '名③'],
    ['姓①', '名①', '名②'],
    ['姓①', '名①', '名②', '名③'],
    ['法人名'],
    ['法人名', '姓①', '名①'],
    ['姓①', '名①'],
    ['姓①', '名①', '姓②', '名②'],
    ['法人名', '肩書', '姓①', '名①'],
  ];

  var NAIRE_CAPTION_METHODS = [3, 4, 5, 6, 7, 11];


  function setNoshiStepVisibility(el, show) {
    if (!el) return;
    if (show) {
      el.style.display = '';
      el.removeAttribute('hidden');
    } else {
      el.style.display = 'none';
      el.setAttribute('hidden', '');
    }
  }

  function isNoshiStepVisible(el) {
    if (!el) return false;
    if (el.hasAttribute('hidden')) return false;
    if (el.style.display === 'none') return false;
    return true;
  }

  function scrollOptionModalToElement(container, targetEl) {
    if (!isNoshiStepVisible(targetEl)) return;

    var modal = container.closest('.option-modal');
    var panel = modal ? modal.querySelector('.option-modal__panel') : null;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (!isNoshiStepVisible(targetEl)) return;

        if (panel) {
          var panelRect = panel.getBoundingClientRect();
          var targetRect = targetEl.getBoundingClientRect();
          var scrollTop = panel.scrollTop + (targetRect.top - panelRect.top) - 12;
          panel.scrollTo({ top: Math.max(0, scrollTop), behavior: 'smooth' });
          return;
        }

        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function scrollToNoshiNextStep(container, step) {
    var target = null;

    if (step === 'required') {
      target = container.querySelector('[data-noshi-purpose]');
    } else if (step === 'purpose') {
      target = container.querySelector('[data-noshi-type]');
    } else if (step === 'type') {
      target = container.querySelector('[data-noshi-style]');
    } else if (step === 'style') {
      target = container.querySelector('[data-naire-method]');
    } else if (step === 'naire-method') {
      target = container.querySelector('[data-naire-inputs]');
    }

    scrollOptionModalToElement(container, target);
  }

  function getNoshiStepState(container) {
    var noshiYes = container.querySelector('input[name="properties[のし]"][value="のし必要"]');
    var isRequired = !!(noshiYes && noshiYes.checked);
    var purposeSelect = container.querySelector('select[name="properties[のし用途]"]');
    var hasPurpose = !!(purposeSelect && purposeSelect.value && purposeSelect.value !== '');
    var typeChecked = container.querySelector('input[name="properties[のし種類]"]:checked:not([disabled])');
    var hasType = !!(typeChecked && !typeChecked.hasAttribute('hidden'));
    var styleChecked = container.querySelector('input[name="properties[のしの付け方]"]:checked');
    var hasStyle = !!styleChecked;
    return {
      isRequired: isRequired,
      hasPurpose: hasPurpose,
      hasType: hasType,
      hasStyle: hasStyle,
    };
  }

  function resetNoshiTypeSelection(container) {
    container.querySelectorAll('input[name="properties[のし種類]"]').forEach(function (r) {
      r.checked = false;
    });
  }

  function setNoshiInputsEnabled(container, selector, enabled, clearText) {
    container.querySelectorAll(selector).forEach(function (inp) {
      inp.disabled = !enabled;
      if (!enabled && clearText && inp.type !== 'radio') inp.value = '';
    });
  }

  function updateOmotegaki(container, allowShow) {
    var omotegakiEl = container.querySelector('[data-noshi-omotegaki]');
    if (!omotegakiEl) return;
    var checkedType = container.querySelector('input[name="properties[のし種類]"]:checked:not([disabled])');
    var showOg =
      allowShow && !!(checkedType && !checkedType.hasAttribute('hidden') && checkedType.value.indexOf('自由入力') >= 0);
    setNoshiStepVisibility(omotegakiEl, showOg);
    var omotegakiInput = omotegakiEl.querySelector('input[name="properties[表書き]"]');
    if (omotegakiInput) {
      omotegakiInput.disabled = !showOg;
      if (!showOg) omotegakiInput.value = '';
    }
  }

  function updateNoshiTypeList(container) {
    var purposeSelect = container.querySelector('select[name="properties[のし用途]"]');
    var typeFieldset = container.querySelector('[data-noshi-type]');
    if (!purposeSelect || !typeFieldset) return;

    var purposeOpt = purposeSelect.selectedOptions && purposeSelect.selectedOptions[0];
    var purposeKey =
      purposeOpt && purposeOpt.dataset && purposeOpt.dataset.purpose ? String(purposeOpt.dataset.purpose) : '';

    var emptyEl = typeFieldset.querySelector('[data-noshi-type-empty]');
    var radios = typeFieldset.querySelectorAll('input[name="properties[のし種類]"]');
    var labels = typeFieldset.querySelectorAll('label[data-noshi-purpose]');

    if (!purposeKey) {
      radios.forEach(function (r) {
        r.checked = false;
        r.disabled = true;
        r.setAttribute('hidden', '');
      });
      labels.forEach(function (l) {
        l.setAttribute('hidden', '');
      });
      if (emptyEl) emptyEl.removeAttribute('hidden');
      return;
    }

    if (emptyEl) emptyEl.setAttribute('hidden', '');

    radios.forEach(function (r) {
      var match = String(r.dataset.noshiPurpose || '') === purposeKey;
      if (match) {
        r.removeAttribute('hidden');
        r.disabled = false;
      } else {
        r.checked = false;
        r.disabled = true;
        r.setAttribute('hidden', '');
      }
    });
    labels.forEach(function (l) {
      if (String(l.dataset.noshiPurpose || '') === purposeKey) {
        l.removeAttribute('hidden');
      } else {
        l.setAttribute('hidden', '');
      }
    });
  }

  /** のし詳細の段階表示を同期（用途 → 種類 → 付け方 → 名入れ） */
  function updateNoshiStepVisibility(container) {
    var purposeEl = container.querySelector('[data-noshi-purpose]');
    var typeEl = container.querySelector('[data-noshi-type]');
    var styleEl = container.querySelector('[data-noshi-style]');
    var naireMethodEl = container.querySelector('[data-naire-method]');
    var naireInputsEl = container.querySelector('[data-naire-inputs]');
    var state = getNoshiStepState(container);

    var showPurpose = state.isRequired;
    var showType = state.isRequired && state.hasPurpose;
    var showStyle = state.isRequired && state.hasType;
    var showNaire = state.isRequired && state.hasType && state.hasStyle;

    setNoshiStepVisibility(purposeEl, showPurpose);
    setNoshiStepVisibility(typeEl, showType);
    setNoshiStepVisibility(styleEl, showStyle);
    setNoshiStepVisibility(naireMethodEl, showNaire);
    setNoshiStepVisibility(naireInputsEl, showNaire);

    setNoshiInputsEnabled(container, '[data-noshi-purpose] select', showPurpose, true);
    setNoshiInputsEnabled(
      container,
      '[data-noshi-type] input[name="properties[のし種類]"]',
      showType,
      false
    );
    setNoshiInputsEnabled(
      container,
      '[data-noshi-style] input[name="properties[のしの付け方]"]',
      showStyle,
      false
    );
    setNoshiInputsEnabled(container, '[data-naire-method] input', showNaire, false);
    setNoshiInputsEnabled(container, '[data-naire-inputs] input', showNaire, true);

    if (!state.hasPurpose) {
      resetNoshiTypeSelection(container);
    }

    updateOmotegaki(container, showStyle);
    if (showNaire) {
      updateNaireFields(container);
    }
  }

  function updateNaireFields(container) {
    var naireWrap = container.querySelector('[data-naire-inputs]');
    if (!naireWrap) return;

    var methodRadio = container.querySelector('input[name="properties[名入れ方法]"]:checked');
    var methodIdx =
      methodRadio && methodRadio.dataset.method !== undefined ? parseInt(methodRadio.dataset.method, 10) : 0;
    if (isNaN(methodIdx)) methodIdx = 0;

    var fields = NAIRE_METHOD_FIELDS[methodIdx] || [];
    var showPrintBlock = methodIdx !== 0;

    var printHeading = naireWrap.querySelector('.naire-print-heading');
    if (printHeading) printHeading.style.display = showPrintBlock ? '' : 'none';

    naireWrap.querySelectorAll('.naire-field').forEach(function (row) {
      var inputs = row.querySelectorAll('input[data-field]');
      var anyShow = Array.prototype.some.call(inputs, function (inp) {
        return fields.indexOf(inp.getAttribute('data-field')) >= 0;
      });
      row.style.display = anyShow ? '' : 'none';
      if (anyShow) row.removeAttribute('hidden');
      else row.setAttribute('hidden', '');

      inputs.forEach(function (inp) {
        var fname = inp.getAttribute('data-field');
        var show = fields.indexOf(fname) >= 0;
        inp.disabled = !show;
        if (!show) inp.value = '';
        var fieldCol = inp.closest('.field');
        if (fieldCol) fieldCol.style.display = show ? '' : 'none';
      });

      if (row.classList.contains('naire-field--pair') && anyShow) {
        var pairKey = row.getAttribute('data-field-pair');
        var n = pairKey === '姓名1' ? 1 : pairKey === '姓名2' ? 2 : 3;
        var seiKey = n === 1 ? '姓①' : n === 2 ? '姓②' : '姓③';
        var meiKey = n === 1 ? '名①' : n === 2 ? '名②' : '名③';
        var titleChar = n === 1 ? '①' : n === 2 ? '②' : '③';
        var hasSei = fields.indexOf(seiKey) >= 0;
        var hasMei = fields.indexOf(meiKey) >= 0;
        var labelEl = row.querySelector('[data-naire-pair-heading]');
        if (labelEl) {
          if (hasSei && hasMei) labelEl.textContent = '姓名' + titleChar;
          else if (hasSei) labelEl.textContent = seiKey;
          else if (hasMei) labelEl.textContent = meiKey;
        }
      }
    });

    var cap = naireWrap.querySelector('[data-naire-caption]');
    if (cap) {
      var showCap = showPrintBlock && NAIRE_CAPTION_METHODS.indexOf(methodIdx) >= 0;
      cap.style.display = showCap ? '' : 'none';
      cap.hidden = !showCap;
    }
  }

  function initNoshiOptions(root) {
    var containers = root.querySelectorAll('[data-noshi-option]');
    containers.forEach(function (container) {
      var detailEl = container.querySelector('[data-noshi-detail]');
      var omotegakiEl = container.querySelector('[data-noshi-omotegaki]');
      var noshiRadios = container.querySelectorAll('input[name="properties[のし]"]');
      var typeRadios = container.querySelectorAll('input[name="properties[のし種類]"]');
      var styleRadios = container.querySelectorAll('input[name="properties[のしの付け方]"]');
      var naireRadios = container.querySelectorAll('input[name="properties[名入れ方法]"]');
      var purposeSelect = container.querySelector('select[name="properties[のし用途]"]');

      if (!detailEl) return;

      function updateNoshiDetail(shouldScroll) {
        var noshiYes = container.querySelector('input[name="properties[のし]"][value="のし必要"]');
        var isRequired = noshiYes && noshiYes.checked;
        detailEl.style.display = isRequired ? '' : 'none';
        if (!isRequired) {
          detailEl.querySelectorAll('input, select').forEach(function (el) {
            el.disabled = true;
          });
          updateNoshiStepVisibility(container);
          return;
        }
        updateNoshiTypeList(container);
        updateNoshiStepVisibility(container);
        if (shouldScroll) {
          scrollToNoshiNextStep(container, 'required');
        }
      }

      function syncNoshiSteps(nextStep) {
        var noshiYes = container.querySelector('input[name="properties[のし]"][value="のし必要"]');
        if (!noshiYes || !noshiYes.checked) return;
        updateNoshiTypeList(container);
        updateNoshiStepVisibility(container);
        if (nextStep) {
          scrollToNoshiNextStep(container, nextStep);
        }
      }

      noshiRadios.forEach(function (radio) {
        radio.addEventListener('change', function (e) {
          updateNoshiDetail(e.isTrusted);
        });
      });
      if (purposeSelect) {
        purposeSelect.addEventListener('change', function (e) {
          resetNoshiTypeSelection(container);
          if (purposeSelect.value && e.isTrusted) {
            syncNoshiSteps('purpose');
          } else {
            syncNoshiSteps();
          }
        });
      }
      typeRadios.forEach(function (radio) {
        radio.addEventListener('change', function (e) {
          syncNoshiSteps(e.isTrusted ? 'type' : null);
        });
      });
      styleRadios.forEach(function (radio) {
        radio.addEventListener('change', function (e) {
          syncNoshiSteps(e.isTrusted ? 'style' : null);
        });
      });
      naireRadios.forEach(function (radio) {
        radio.addEventListener('change', function (e) {
          var noshiYes = container.querySelector('input[name="properties[のし]"][value="のし必要"]');
          if (!noshiYes || !noshiYes.checked) return;
          updateNaireFields(container);

          var method = radio.dataset.method;
          if (e.isTrusted && method && method !== '0') {
            scrollToNoshiNextStep(container, 'naire-method');
          }
        });
      });

      updateNoshiDetail();
    });
  }


  function validateRequiredOptions(modal) {
    if (!modal) return true;
    var variantSelects = modal.querySelector('variant-selects');
    var checkedVariant = variantSelects
      ? variantSelects.querySelector('input[type="radio"]:checked')
      : null;
    if (checkedVariant) {
      var selectedSku = String(checkedVariant.dataset.variantSku || '').toUpperCase();
      var skipsGiftOptions =
        checkedVariant.dataset.noGiftOption === 'true' ||
        /-(SEAL|DATA)$/.test(selectedSku);
      if (skipsGiftOptions) return true;
    }

    var designRadios = modal.querySelectorAll('input[name="properties[フォルダーデザイン]"]');
    if (designRadios.length > 0) {
      var designChecked = Array.prototype.some.call(designRadios, function (r) { return r.checked; });
      if (!designChecked) return false;
    }

    var wrappingRadios = modal.querySelectorAll('input[name="properties[ラッピング]"]');
    if (wrappingRadios.length > 0) {
      var wrappingChecked = Array.prototype.some.call(wrappingRadios, function (r) { return r.checked; });
      if (!wrappingChecked) return false;
    }

    var noshiRequired = modal.querySelector('[data-noshi-required]');
    if (noshiRequired) {
      var noshiYes = modal.querySelector('input[name="properties[のし]"][value="のし必要"]');
      var noshiNo = modal.querySelector('input[name="properties[のし]"][value="のし不要"]');
      if (!noshiYes || !noshiNo) return true;
      if (noshiNo.checked) return true;

      var purposeSelect = modal.querySelector('select[name="properties[のし用途]"]');
      if (purposeSelect && (!purposeSelect.value || purposeSelect.value === '')) return false;

      var typeChecked = modal.querySelector('input[name="properties[のし種類]"]:checked');
      if (!typeChecked || typeChecked.disabled || typeChecked.hidden) return false;
      var freeText = modal.querySelector('[name="properties[表書き]"]');
      if (typeChecked.value.includes('自由入力') && (!freeText || !freeText.value.trim())) return false;

      var noshiStyleChecked = modal.querySelector('input[name="properties[のしの付け方]"]:checked');
      if (!noshiStyleChecked) return false;

      var naireMethodRadio = modal.querySelector('input[name="properties[名入れ方法]"]:checked');
      if (!naireMethodRadio) return false;

      var methodIdx =
        naireMethodRadio.dataset.method !== undefined ? parseInt(naireMethodRadio.dataset.method, 10) : 0;
      if (isNaN(methodIdx)) methodIdx = 0;

      if (methodIdx > 0) {
        var reqFields = NAIRE_METHOD_FIELDS[methodIdx] || [];
        for (var fi = 0; fi < reqFields.length; fi++) {
          var fn = reqFields[fi];
          var inp = modal.querySelector('[data-field="' + fn + '"]');
          if (!inp || !String(inp.value || '').trim()) return false;
        }
      }
    }

    return true;
  }


  if (customElements.get('scg-course-card')) return;
  customElements.define('scg-course-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.quantity = this.form.elements.namedItem('quantity');
      this.dialog = this.querySelector('dialog');
      this.modalQuantity = this.querySelector('[data-scg-modal-quantity]');
      this.status = this.querySelector('[data-scg-status]');
      initNoshiOptions(this);
      this.querySelector('[data-scg-open]')?.addEventListener('click', (event) => {
        if (!this.quantity.reportValidity()) return;
        this.opener = event.currentTarget;
        this.modalQuantity.value = this.quantity.value;
        this.updateTotal();
        this.dialog.showModal();
      });
      this.querySelector('[data-scg-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog?.addEventListener('close', () => this.opener?.focus());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      });
      this.quantity.addEventListener('input', () => {
        if (this.modalQuantity) this.modalQuantity.value = this.quantity.value;
        this.updateTotal();
      });
      this.modalQuantity?.addEventListener('input', () => {
        this.quantity.value = this.modalQuantity.value;
        this.updateTotal();
      });
      this.form.addEventListener('submit', (event) => this.addToCart(event));
      this.form.addEventListener('invalid', (event) => {
        if (this.dialog?.open && event.target === this.quantity) {
          event.preventDefault();
          this.modalQuantity.reportValidity();
        }
      }, true);
    }
    updateTotal() {
      const total = this.querySelector('[data-scg-total]');
      if (total) total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'ja-JP', {
        style: 'currency', currency: this.dataset.currency
      }).format(Number(this.dataset.unitPrice) * (Number(this.quantity.value) || 0) / 100);
    }
    message(text) {
      this.status.textContent = text;
      const error = this.querySelector('[data-scg-error]');
      if (error) error.textContent = text;
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy) return;
      if (this.modalQuantity && !this.modalQuantity.reportValidity()) return;
      if (!this.quantity.reportValidity()) return;
      if (!validateRequiredOptions(this.dialog)) {
        this.message('熨斗の用途・種類・名入れなど、必要な項目を入力してください。');
        return;
      }
      const submitButtons = [...this.querySelectorAll('button[type="submit"], [data-scg-open]')];
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      submitButtons.forEach(button => button.disabled = true);
      this.message('');
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData(this.form);
      // Disabled/hidden noshi alternatives must never become stale order properties.
      this.querySelectorAll('[data-noshi-purpose][type="radio"][hidden]').forEach(input => {
        if (input.checked) body.delete(input.name);
      });
      if (cart) {
        body.append('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        body.append('sections_url', window.location.pathname);
        cart.setActiveElement(this.opener || event.submitter);
      }
      let added = false;
      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST', headers: {'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'}, body
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'カートに追加できませんでした。');
        added = true;
        this.dialog?.close();
        this.message('カートに追加しました。');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'scg-course-card', productVariantId: body.get('id'), cartData: data});
        }
        if (cart && data.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location.assign(window.routes?.cart_url || '/cart');
        }
      } catch (error) {
        this.message(added ? '追加済みです。カートを開いて内容をご確認ください。' : (error.message || '通信に失敗しました。カートをご確認ください。'));
        if (added) {
          const link = document.createElement('a');
          link.href = window.routes?.cart_url || '/cart';
          link.textContent = 'カートを見る';
          this.status.append(' ', link);
        }
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        submitButtons.forEach(button => button.disabled = false);
      }
    }
  });
})();
